import { useFormContext } from 'react-hook-form';
export default function useGetFormDataAsParams() {
    const { getValues } = useFormContext();
    return () => {
        const params = new URLSearchParams({
            ...getValues(),
        });
        // delete sessions if it's already set here..
        params.delete('Sessions');
        const sessions = getValues('Sessions');
        if (sessions) {
            params.append('Sessions', JSON.stringify(sessions));
        }
        return params;
    };
}
